export const routes = (prefix = `claims`) => [
    {
        path: `/${prefix}/org-receipt`,
        name: `${prefix}.org-receipt.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.org-receipt.create`,
                PageDescription: "Claims: Organization receipts",
            },
        },
    },
];